import { CancelToken } from "axios";
import { ConfigurationProvider } from "../../../lib/infrastructure/configuration/ConfigurationProvider";
import { HttpClient } from "../../../lib/infrastructure/http/HttpClient";
import { UrlUtility } from "../../../lib/utils/UrlUtility";
import { AgenticEnvelope, MetadataExplainDTO } from "../models/services/AgenticMetadataDTO";
import { PageMetadata } from "../models/PageMetadata";
import { toPageMetadata } from "../utils/toPageMetadata";

const Route = (path: string) =>
    UrlUtility.join(ConfigurationProvider.getConfiguration().App.BackendUrl, path);

/**
 * Reads page metadata through Ark.Core's agentic facade (`api/agentic/v1`), the same API the orbital CLI and
 * Ark Studio use. Read-only: tags and expedition are set by page rules / the cascade / tag inference, not here.
 */
export class AgenticPageService {
    async getPageMetadata(pageId: string | number, cancelToken?: CancelToken): Promise<PageMetadata> {
        const res = await HttpClient.sessionRequest<AgenticEnvelope<MetadataExplainDTO>>({
            method: "GET",
            url: Route(`/api/agentic/v1/pages/${pageId}/metadata/explain`),
            headers: { "X-Orbital-Client": "ark-web" },
            cancelToken,
        });
        return toPageMetadata(res.data?.data);
    }
}
